import { render, staticRenderFns } from "./RequestWizardFerramentasNorven.vue?vue&type=template&id=56ddc3eb&"
import script from "./RequestWizardFerramentasNorven.vue?vue&type=script&lang=js&"
export * from "./RequestWizardFerramentasNorven.vue?vue&type=script&lang=js&"
import style0 from "./RequestWizardFerramentasNorven.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSelect,VTabItem,VTextField})
